export const StudioAuthRoutes = {
  refreshToken: () => '/auth/token/refresh',
  generateToken: () => '/auth/token',
  exchangeToken: () => '/auth/oauth/token',
};
